import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.repairer}quotes`;

export interface AddQuoteTaskCommandArgs {
  quoteId: string;
}

export const addQuoteTaskRequest = (
  payload: AddQuoteTaskCommandArgs,
): ApiRequestDescriptor => ({
  url: `${ENDPOINT}/${payload.quoteId}/items`,
  config: { method: SUPPORTED_METHODS.POST, json: {} },
});

export const addQuoteTaskCommand = async (
  payload: AddQuoteTaskCommandArgs,
): Promise<BackResponse<string> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<string>>(
      addQuoteTaskRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
